export default "__VITE_ASSET__7kwXj0YT__"